import { Typography, Button, Box, Container } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import React, { useEffect, useState, useRef } from 'react';
import ResponsiveAppBarAlt from './ResponsiveAppBarAlt';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const ScrollAnimation = () => {
  const [isHeroNavVisible, setIsHeroNavVisible] = useState(true);
  const heroNavWrapperRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const screenHeight = window.innerHeight;


    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsHeroNavVisible(entry.isIntersecting);
                const navbar = document.querySelector(".navbar.alt");
                if (navbar) {
                    if (!entry.isIntersecting) {
                        navbar.style.marginTop = "0px";
                    } else {
                        navbar.style.marginTop = "-100px";
                    }
                }
            },
            { threshold: 0.01 }
    );

    if (heroNavWrapperRef.current) {
      observer.observe(heroNavWrapperRef.current);
    }

    return () => {
      if (heroNavWrapperRef.current) {
        observer.unobserve(heroNavWrapperRef.current);
      }
    };
  }, []);


  return (

    <div className="App">
<ResponsiveAppBarAlt />

<main>

  <Box className="heroWrapper subpage" id="start">

  <img src="Unternehmen.webp" className='herobackimg' />
    <Box className='heroWrapperLayer'></Box>
    <Container maxWidth="lg" className="containerHero" /*sx={{width: 300,backgroundColor: 'success.main',}}*/>

    </Container>

    <Box className="heroNavWrapper" ref={heroNavWrapperRef}>
      <HashLink className='navItemHero' smooth to="/#leistungen">Leistungen</HashLink>
      <HashLink className='navItemHero' smooth to="/#notare">Notare</HashLink>
      <HashLink className='navItemHero' smooth to="/team">Team</HashLink>
      <HashLink className='navItemHero' smooth to="/Blog">Blog</HashLink>
      <HashLink className='navItemHero' smooth to="#kontakt">Kontakt</HashLink>
      <HashLink className='navItemHero flex' smooth to="/en"><img src="en-flag.png" className='navFlagIcon' />EN</HashLink>
    </Box>

    {/* <div className="heroCTAWrapper">
      <Button href="#" target='_blank' variant='contained' className='mandantenCTATop'>Mandanten Login<img src='arrow-weiss.png' className='servOptItemArrow' /></Button>
    </div> */}
  </Box>


  <Box className="mainWrapper">

    <Container maxWidth="lg" className="subPageContainerThin">

      <HashLink className='breadcrumb' smooth to="/#leistungen">Leistungen</HashLink>
            <Typography variant='h1' className='subTitle'>Unternehmen</Typography>


      <Box className="intendTextWrapper">
        <Typography variant='h2' className='sectionTitle'>Unternehmen gründen</Typography>
        <Box className="textintendInnerWrapper margin">
        <Typography variant='body1' className='sectionText'>
       Wer ein Unternehmen gründet, muss sich vor allem überlegen, welche Rechtsform am besten zu ihm passt. Die meisten Gründer wählen die Gesellschaft mit beschränkter Haftung (GmbH), weil nur die GmbH für Schulden des Unternehmens haftet. Die Gläubiger der GmbH können nicht auf das Privatvermögen des Unternehmensinhabers zugreifen. Zur Gründung der GmbH müssen der oder die Gründer einen notariell beurkundeten Gesellschaftsvertrag schließen. Der Notar berät zu der genauen Ausgestaltung des Gesellschaftsvertrages und belehrt über wichtige Rechtsfolgen der Gründung. Außerdem übernimmt er die Anmeldung der neu gegründeten GmbH beim Handelsregister. 
       </Typography>
       {/* <Button className='btnSecondary'><HashLink smooth to="https://dialog.ht-notare.de/founding">Unternehmen gründen Formular</HashLink></Button> */}
       <Button className='btnSecondary'><HashLink smooth to="#kontakt">Kontaktformular</HashLink></Button>
        </Box>
      </Box>

      <Box className="intendTextWrapper">
        <Typography variant='h2' className='sectionTitle'>Unternehmen verkaufen</Typography>
        <Box className="textintendInnerWrapper margin">
        <Typography variant='body1' className='sectionText'>
       Wer sein Unternehmen verkaufen will, sollte sich angesichts der viele rechtlichen und steuerlichen Folgen unbedingt beraten lassen. Wer eine GmbH verkaufen will, muss den Kaufvertrag zwingend bei einem Notar beurkunden lassen. Der Notar gestaltet den Kaufvertrag so, dass er einen fairen Ausgleich der Interessen von Käufer und Verkäufer schafft. Außerdem überwacht er die Zahlung des Kaufpreises und nimmt Anmeldungen zum Handelsregister vor. Zugleich kann der Notar die Abstimmung mit dem Steuerberater übernehmen. 
       </Typography>
       {/* <Button className='btnSecondary'><HashLink smooth to="#kontakt">Unternehmensverkauf Formular</HashLink></Buton> */}
       <Button className='btnSecondary'><HashLink smooth to="#kontakt">Kontaktformular</HashLink></Button>
        </Box>
      </Box>

      <Box className="intendTextWrapper">
        <Typography variant='h2' className='sectionTitle'>Unternehmen umwandeln</Typography>
        <Box className="textintendInnerWrapper margin">
        <Typography variant='body1' className='sectionText'>
       Aus verschiedenen Gründen kann es sinnvoll sein, ein Unternehmen neu zu strukturieren. Beispielsweise können zwei Gesellschaften miteinander verschmelzen, sodass nur noch eine Gesellschaft Inhaberin der Rechte und Pflichten beider vormaligen Gesellschaften ist. Oder das Unternehmen muss seine Rechtsform wechseln, weil es sich gegen bestimmte rechtliche Risiken schützen will. Bei diesen Umwandlungsmaßnahmen berät sie der Notar, beurkundet die jeweiligen Vorgänge und nimmt die Anmeldung beim Handelsregister vor. Steuerliche Fragen kann er unmittelbar mit dem Steuerberater klären. 
       </Typography>
       {/* <Button className='btnSecondary'><HashLink smooth to="https://dialog.ht-notare.de/companychange">Unternehmen umwandeln Formular</HashLink></Button> */}
       <Button className='btnSecondary'><HashLink smooth to="#kontakt">Kontaktformular</HashLink></Button>
        </Box>
      </Box>

      <Box className="intendTextWrapper">
        <Typography variant='h2' className='sectionTitle'>Unternehmen beenden</Typography>
        <Box className="textintendInnerWrapper margin">
        <Typography variant='body1' className='sectionText'>
       Wer sein Unternehmen beenden will, muss dafür ein sog. Liquidationsverfahren durchlaufen. Im Rahmen dieses Verfahrens wird das vorhandene Unternehmensvermögen verkauft und damit zu Geld gemacht. Aus dem gewonnenen Geldvermögen muss der Unternehmensinhaber die Forderungen von Gläubigern des Unternehmens erfüllen. Erst nachdem alle Forderungen beglichen sind, kann der Unternehmensinhaber das restliche Vermögen für sich selbst vereinnahmen. Der Notar berät sie zur Gestaltung und den Folgen der Liquidation. Er bereitet auch die erforderlichen Anmeldungen zum Handelsregister vor. 
       </Typography>
       {/* <Button className='btnSecondary'><HashLink smooth to="#kontakt">Unternehmen beenden Formular</HashLink></Button> */}
       <Button className='btnSecondary'><HashLink smooth to="#kontakt">Kontaktformular</HashLink></Button>
        </Box>
      </Box>

    </Container>

      

                     <Box className="map" id="map">
                                                    <Box className="contactMap">
                    
                                                        {/* <iframe width="100%" height="100%" frameBorder="0" allowFullScreen allow="geolocation" src="//umap.openstreetmap.de/en/map/notare-harbecke-thelen_85729?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=false&tilelayersControl=null&embedControl=false&datalayersControl=null&onLoadPanel=none&captionBar=false&captionMenus=false&captionControl=null&locateControl=null&measureControl=null"></iframe> */}
                    
                                                        <a href="https://maps.app.goo.gl/BiTJESJc6NsTJLce6" target="_blank" class="contactMapLink">
                                                            <img src="Karte-HT.webp" className="contactMapImg" />
                                                            <a href="http://openstreetmap.org/copyright" target="_blank" className="mapSource">©OpenStreetMap</a>
                                                        </a>
                                                        <Container maxWidth="lg" className="container">
                                                            <Typography variant='body1' paragraph className="contactMapAddress">
                                                                Wenn Sie auf den Link klicken, verlassen Sie unsere Webseite und werden auf Google Maps (ein Service der Google Ireland Limited Gordon House, Barrow Street Dublin 4, Irland) weitergeleitet. Weitere Informationen zu Zweck und Umfang der Datenerhebung und ihrer Verarbeitung erhalten Sie in den Datenschutzerklärungen von <a href="http://www.google.de/intl/de/policies/privacy" target="_blank">Google</a>.
                                                            </Typography>
                                                        </Container>
                                                        
                                                    </Box>
                                                    {/* <Container maxWidth="lg" id="routelink">
                                                        <Typography variant='body1' paragraph className="contactMapRouteLink">Einen Routenplaner finden sie <a href="https://maps.app.goo.gl/BiTJESJc6NsTJLce6" target="_blank">hier</a>.</Typography>
                                                    </Container> */}
                    
                                                </Box>


                      <Box className="section bannergrey" id="kontakt">
                                <Container maxWidth="lg" className="container" id="kontakt">
                                    <Box className="kontaktGrid">
                                        <Box className="kontaktLeftSide smaller">
                                            <Typography variant='h2' className='sectionTitle white small'>
                                                Sie haben Fragen?  <br />
                                                Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Öffnungszeiten</b><br />
                                                Montag bis Freitag von 8:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch ab 13:00 Uhr geschlossen<br />
                                                Spätere Termine sind nach Vereinbarung möglich<br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Telefon</b><br />
                                                Sie erreichen uns unter: 02241 66444<br />
                                                Montag bis Freitag von 9:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch nur bis 13:00 Uhr. <br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>E-mail: info@ht-notare.de</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Fax: 02241 55161</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Anfahrt und Parkmöglichkeiten</b><br />
                                                Das Büro befindet sich im Zentrum von Siegburg im Geschäftshaus Am Brauhof 2. Die Kanzleiräume liegen in der ersten Etage und sind mittels eines Aufzugs und Treppenlifts barrierefrei zugängig. Im Parkzentrum Holzgasse (Scheerengasse 5, 53721 Siegburg) können Sie die mit „HT Notare“ markierten Stellplätze 17a, 20, 27 und 29 kostenfrei nutzen. Diese erreichen Sie, indem Sie nach der Einfahrt in die Tiefgarage rechts abbiegen und dann in dieser Richtung bis zum Ende der Garage durchfahren. Hierbei passieren Sie eine rot leuchtende Ampel. Von den Stellplätzen aus gelangen Sie durch eine eigene Tür mit Klingelschild in das Treppenhaus und zum Lift. Weitere (kostenpflichtige) Parkmöglichkeiten befinden sich im Parkhaus von Galeria Kaufhof und Saturn, etwa 100 Meter entfernt liegend vom Büro.
                                            </Typography>
                                        </Box>
                                        <Contactform />
                                    </Box>
                                </Container>
                            </Box>



  </Box>

</main >
<Footer />
    </div >
  );
};

export default ScrollAnimation;